import { render, staticRenderFns } from "./company-data.container.vue?vue&type=template&id=57a67d8d&scoped=true&lang=pug"
import script from "./company-data.container.vue?vue&type=script&lang=ts"
export * from "./company-data.container.vue?vue&type=script&lang=ts"
import style0 from "./company-data.container.vue?vue&type=style&index=0&id=57a67d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a67d8d",
  null
  
)

export default component.exports